import React from 'react';
import PropTypes from 'prop-types';
import ScrollToNext from '@components/ScrollToNext';
import './style.scss';

const AboutPage = (props, context) => {
  const {
    theme: { colorPrimary, colorHighlight, bgPrimary, textPrimary }
  } = context;

  return (
    <div className="about-page" style={{ backgroundColor: bgPrimary }}>
      <style jsx="true">
        {`
          ::selection {
            background-color: ${colorHighlight};
          }
          .about-page .highlight {
            background-color: ${colorHighlight};
          }
          .about-page a {
            color: ${colorPrimary};
          }
          .about-page a:hover {
            background-color: ${colorHighlight};
          }
        `}
      </style>
      <div className="content-grid">
        <h1 style={{ color: colorPrimary }}>About</h1>
        <div className="about-wrapper">
          <div className="about-content" style={{ color: textPrimary }}>
      <p>I'm a Member of Technical Staff at <a href="https://openai.com/">OpenAI</a>, where I build the underlying infrastructure for services such as <a href="https://chatgpt.com/">ChatGPT</a>, <a href="https://openai.com/codex/">Codex</a>, and the <a href="https://platform.openai.com/">API platform</a>. Previously, I was part of the <a href="https://techsysinfra.google/">Technical Infrastructure group</a> at <a href="https://about.google/">Google</a>, working on networked and distributed systems for privacy-preserving technologies and machine learning. Before that, I was a research assistant pursuing a Ph.D. in <a href="https://cs.berkeley.edu/">Computer Science</a> at <a href="http://www.berkeley.edu/">University of California, Berkeley</a>. I worked at <a href="http://rise.cs.berkeley.edu/">RISELab</a>, the successor of <a href="https://amplab.cs.berkeley.edu/">AMPLab</a> where Apache <a href="https://spark.apache.org/">Spark</a>, <a href="https://mesos.apache.org/">Mesos</a>, and <a href="https://www.ray.io/">Ray</a> were born. At RISELab, I researched computer systems and programming language techniques for secure data processing and reinforcement learning. Earlier in my career,  I worked as a software engineer and researcher for several years developing data infrastructure using Apache <a href="https://hadoop.apache.org/">Hadoop</a>, and improving the efficiency and reliability of cloud networking at <a href="https://www.microsoft.com/en-us/research/">Microsoft</a> and other places.</p>
      <p>I received my M.S. and B.S. in Computer Science from UC Berkeley and <a href="http://www.kaist.ac.kr/en/">KAIST</a> respectively. During my undergraduate years, I was involved in virtualization platform research and learned about the core technology of cloud computing hacking the <a href="https://xenproject.org/developers/teams/xen-hypervisor/">Xen Hypervisor kernel</a>.</p>
          </div>
        </div>
      </div>
      <ScrollToNext pageSelector=".publication-page" />
    </div>
  );
};

AboutPage.contextTypes = {
  theme: PropTypes.any
};

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/AboutPage.js